/**
 * Main page implementation.
 *
 * @author Dmytro Fedotov <d.fedotov@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageMain',
    Page          = require('stb-component-page'),
    app           = require('mag-app'),
    page          = new Page({$node: document.getElementById(id)}),
    PanelSet      = require('mag-component-panel-set'),
    RadioList     = require('mag-component-radio-list'),
    PanelExtended = require('mag-component-panel'),
    LayoutList    = require('mag-component-layout-list'),
    ModalMessage  = require('mag-component-modal'),
    dom           = require('spa-dom'),
    keys          = require('stb-keys'),
    fileSystem    = window.core.plugins.fs,
    Scroll        = require('stb-component-scrollbar'),
    Flicker       = require('spa-component-flicker'),
    ScrollArea    = require('mag-component-scroll-area'),
    $channelsCountWrapper;


$channelsCountWrapper = dom.tag(
    'div',
    {className: 'amountContainer'},
    dom.tag('div', {className: 'amount'}, '4')
);

// make plugin and storage visible in app
app.updater = window.core.plugins.updater;

app.storages = fileSystem.getMountPoints().concat(fileSystem.getHDDInfo());

fileSystem.onMount = function ( state ) {
    console.log('onMount: ' + state);
    app.storages = fileSystem.getMountPoints().concat(fileSystem.getHDDInfo());
    if ( app.pages.usb.active ) {
        if ( app.pages.usb.modalUsbSelect.visible ) {
            app.pages.usb.modalUsbSelect.hide();
        }
        app.pages.usb.middlePanel.reset();
        app.pages.usb.panelSet.focus();
    }
};


page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();


// modal message: exit
page.modalExit = new ModalMessage({
    title: _('Exit'),
    className: 'modalExit',
    events: {
        show: function () { this.children[0].focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new LayoutList({
            size: 2,
            focusIndex: 0,
            data: [
                {
                    items: [{value: _('Yes')}],
                    click: function () {
                        page.modalExit.hide();
                        if ( app.intent && app.intent.data && app.intent.data.closeCallback ) {
                            // if we came here from settings reset and close them too
                            window.core.taskManager.hideAll();
                            app.intent.data.closeCallback();
                            app.intent = null;
                        } else {
                            window.core.call('hide');
                            //app.exit(); // don't work for system app
                        }
                    }
                },
                {
                    items: [{value: _('No')}],
                    click: function () { page.modalExit.hide(); }
                }
            ],
            propagate: true
        })
    ]
});
page.add(page.modalExit);


// left panel (menu)
page.leftPanel = new PanelExtended({title: _('Menu'), children: [], className: 'leftPanel'});
page.leftPanel.add(page.leftPanel.list = new LayoutList({
    cycle: true,
    focusIndex: 0,
    data: [
        {
            items: [{className: 'theme-icon theme-icon-exit', value: ''}, {value: _('Exit')}],
            click: function () {
                page.panelSet.blur();
                page.modalExit.show();
            }
        }
    ]
}));


// right panel (information)
page.rightPanel = new PanelExtended({title: _('Details'), className: 'rightPanel'});
page.rightPanel.scroll = new Scroll({});
page.rightPanel.textArea = new ScrollArea({propagate: true, step: 5, scroll: page.rightPanel.scroll});
page.rightPanel.add(page.rightPanel.textArea, page.rightPanel.scroll);

page.rightPanel.reset = function () {
    var area = page.rightPanel.textArea,
        data, $fragment, index,
        htmlElem;

    area.$body.innerHTML = '';

    try {
        data = page.middlePanel.list.$focusItem.data.items[1].data;
    } catch ( error ) {
        data = null;

    }

    if ( data && data.length ) {
        $fragment = dom.fragment();
        for ( index = 0; index < data.length; index++ ) {
            if ( data[index].type === 'title' ) {
                $fragment.appendChild(dom.tag(
                    'div',
                    {className: 'title theme-subhead-color'},
                    (data[index].data || '') + (typeof data[index].calc === 'function' ? ' ' + data[index].calc() : '' )
                ));
            } else if ( data[index].type === 'text' ) {
                $fragment.appendChild(dom.tag(
                    'div',
                    {},
                    (data[index].data || '') + (typeof data[index].calc === 'function' ? ' ' + data[index].calc() : '' )
                ));
            } else if ( data[index].type === 'html' ) {
                htmlElem = document.createElement('div');
                htmlElem.innerHTML = data[index].data;
                $fragment.appendChild(htmlElem);
            }
        }
        area.$body.appendChild($fragment);
        page.rightPanel.textArea.show();
        page.rightPanel.textArea.init();
    } else {
        page.rightPanel.textArea.hide();
    }
};


// modal message: change auto update condition
page.modalFriquency = new ModalMessage({
    visible: false,
    title: _('Auto update condition'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 3,
            data: [
                {
                    state: app.updater.frequency === app.updater.constants.NEVER,
                    title: _('Never'),
                    value: app.updater.constants.NEVER
                },
                {
                    state: app.updater.frequency === app.updater.constants.WEEKLY,
                    title: _('Weekly'),
                    value: app.updater.constants.WEEKLY
                },
                {
                    state: app.updater.frequency === app.updater.constants.MONTHLY,
                    title: _('Monthly'),
                    value: app.updater.constants.MONTHLY
                }
            ],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    app.updater.frequency = event.$item.data.value;
                    page.rightPanel.reset();
                    page.modalFriquency.hide();
                }
            }
        })
    ]
});
page.add(page.modalFriquency);


// modal message: change beta update condition
page.modalAllowBeta = new ModalMessage({
    visible: false,
    title: _('Update to beta'),
    events: {
        show: function () { this.focus(); },
        hide: function () { page.panelSet.focus(); }
    },
    children: [
        new RadioList({
            cycle: true,
            focusIndex: 0,
            size: 2,
            data: [
                {state: !app.updater.betaUpdate, title: _('OFF'), value: false},
                {state: app.updater.betaUpdate, title: _('ON'), value: true}
            ],
            propagate: true,
            events: {
                'click:item': function ( event ) {
                    app.updater.betaUpdate = event.$item.data.value;
                    page.rightPanel.reset();
                    page.modalAllowBeta.hide();
                }
            }
        })
    ]
});
page.add(page.modalAllowBeta);


// middle panel
page.middlePanel = new PanelExtended({
    title: [{value: _('updates'), className: 'name'}, $channelsCountWrapper],
    main: true,
    children: [],
    className: 'middlePanel'
});

page.middlePanel.sets = {
    main: {
        title: _('updates'),
        index: 0,
        data: [
            {
                items: [
                    {className: 'theme-icon theme-icon-internet'},
                    {
                        value: _('List of releases'),
                        data: [
                            {type: 'title', data: _('Update via server')},
                            {type: 'html', data: '</br>'},
                            {type: 'text', data: _('Update to image from server.')}
                        ]
                    }
                ],
                click: function () {
                    page.middlePanel.reset(page.middlePanel.sets.releases);
                }
            }, {
                items: [
                    {className: 'theme-icon theme-icon-update'},
                    {
                        value: _('Update by URL'),
                        data: [
                            {type: 'title', data: _('Update via URL')},
                            {type: 'html', data: '</br>'},
                            {type: 'text', data: _('Update to image from URL.')}
                        ]
                    }
                ],
                click: function () {
                    page.panelSet.blur();
                    app.route(app.pages.url);
                }
            }, {
                items: [
                    {className: 'theme-icon theme-icon-usb'},
                    {
                        value: _('USB'),
                        data: [
                            {type: 'title', data: _('Update via storage')},
                            {type: 'html', data: '</br>'},
                            {type: 'text', data: _('Update to image from storage device.')}
                        ]
                    }
                ],
                click: function () {
                    page.panelSet.blur();
                    app.route(app.pages.usb);
                }
            }
        ]
    },
    options: {
        title: _('Auto update'),
        index: 0,
        data: [
            {
                items: [{className: 'theme-icon theme-icon-back'}, {value: '..'}],
                click: function () { page.middlePanel.reset(page.middlePanel.sets.main); }
            }, {
                items: [
                    {className: 'theme-icon theme-icon-beta'},
                    {
                        value: _('Update to beta versions'),
                        data: [
                            {type: 'title', data: _('Update to beta versions:')},
                            {type: 'text', calc: function () { return app.updater.betaUpdate ? _('ON') : _('OFF'); }},
                            {type: 'html', data: '</br>'},
                            {type: 'text', data: _('Update to beta versions.')}
                        ]
                    }
                ],
                click: function () {
                    page.panelSet.blur();
                    page.modalAllowBeta.show();
                }
            }, {
                items: [
                    {className: 'theme-icon theme-icon-update'},
                    {
                        value: _('Update frequency'),
                        data: [
                            {type: 'title', data: _('Update frequency:')},
                            {
                                type: 'text',
                                calc: function () {
                                    var localisations = {};

                                    localisations[app.updater.constants.NEVER] = _('Never');
                                    localisations[app.updater.constants.WEEKLY] = _('Weekly');
                                    localisations[app.updater.constants.MONTHLY] = _('Monthly');

                                    return localisations[app.updater.frequency];
                                }
                            },
                            {type: 'html', data: '</br>'},
                            {type: 'text', data: _('Choose frequency of new versions check.')}
                        ]
                    }
                ],
                click: function () {
                    page.panelSet.blur();
                    page.modalFriquency.show();
                }
            }
        ]
    },
    releases: {
        title: _('List of releases'),
        index: 0,
        data: [
            {
                items: [{className: 'theme-icon theme-icon-back'}, {value: '..'}],
                click: function () { page.middlePanel.reset(page.middlePanel.sets.main); }
            }
        ]
    }
};


if ( app.updater.autoUpdateEnabled ) {
    page.middlePanel.sets.main.data.push({
        items: [
            {className: 'theme-icon theme-icon-folder'},
            {
                value: _('Auto update'),
                data: [
                    {type: 'title', data: _('Auto update')},
                    {type: 'html', data: '</br>'},
                    {type: 'text', data: _('Choose auto update conditions.')}
                ]
            }
        ],
        click: function () {
            page.middlePanel.reset(page.middlePanel.sets.options);
        }
    });
}


page.middlePanel.releaseListUpdate = function () {
    var items = app.updater.list;

    //    items = [{
    //        name: '0.2.20-a7.7-256',
    //        url: 'http://update.infomir.com/mag/256/imageupdate_0.2.20-a7.7-256',
    //        type: 'release',
    //        date: '2016-08-19T17:06:25.000Z',
    //        descr: '0.2.20-alpha7.7'
    //    }, {
    //        name: '2.20.01-256',
    //        url: 'http://update.infomir.com/mag/256/imageupdate_2.20.01-256',
    //        type: 'release',
    //        date: '2017-02-27T14:50:14.000Z',
    //        descr: '2.20.01-256'
    //    }, {
    //        name: '2.20.01-259',
    //        url: 'http://update.infomir.com/mag/256/imageupdate_2.20.01-256',
    //        type: 'release',
    //        date: '2019-02-27T14:50:14.000Z',
    //        descr: '9.20.01-256'
    //    }];

    page.middlePanel.sets.releases.data = [
        {
            items: [{className: 'theme-icon theme-icon-back'}, {value: '..'}],
            click: function () { page.middlePanel.reset(page.middlePanel.sets.main); }
        }
    ];

    items.forEach(function ( item, index, array ) {
        page.middlePanel.sets.releases.data.push({
            items: [
                {className: 'theme-icon theme-icon-file'},
                {
                    value: item.name,
                    data: [
                        {type: 'title', data: _('New version')},
                        {type: 'html', data: '</br>'},
                        {type: 'text', data: _('Name:') + ' ' + item.name},
                        {type: 'text', data: _('Description:') + ' ' + item.descr},
                        {type: 'text', data: _('Type:') + ' ' + item.type},
                        {type: 'text', data: _('Date:') + ' ' + (new Date(item.date)).toString()},
                        {type: 'html', data: '</br>'},
                        {type: 'title', data: _('Current version')},
                        {type: 'html', data: '</br>'},
                        {type: 'text', data: _('Name:') + ' ' + app.updater.current.version},
                        {type: 'text', data: _('Description:') + ' ' + app.updater.current.description},
                        {type: 'text', data: _('Date:') + ' ' + app.updater.current.date.toString()}
                    ]
                }
            ],
            click: function () {
                var wholeArray = array.slice();

                page.panelSet.blur();
                wholeArray.splice(index, 1);
                app.route(app.pages.info, [item].concat(wholeArray));
            }
        });
    });
};

page.middlePanel.resetTimeOut = null;
page.middlePanel.reset = function ( listSet ) {
    // prevent reset call spam
    clearTimeout(page.middlePanel.resetTimeOut);
    // Check downloads info change every "n" (depends on plugin config) seconds.
    page.middlePanel.resetTimeOut = setTimeout(function () {
        var body,
            list = page.middlePanel.list;

        if ( page.middlePanel.currentSet ) {
            page.middlePanel.currentSet.index = list.$focusItem.index;
        }
        page.middlePanel.currentSet = listSet;
        body = {data: listSet.data};
        $channelsCountWrapper.firstChild.innerText = listSet.data.length;
        body.focusIndex = listSet.index < listSet.data.length ? listSet.index : 0;
        page.middlePanel.scroll.init({realSize: listSet.data.length, viewSize: 7});
        page.middlePanel.scroll.show();
        list.init(body);
        page.middlePanel.$title.init({data: [listSet.title]});
    }, 300);
};

page.middlePanel.scroll = new Scroll({});
page.middlePanel.add(page.middlePanel.list = new LayoutList({
    cycle: true,
    scroll: page.middlePanel.scroll,
    focusIndex: 0,
    size: 7,
    data: page.middlePanel.sets.main.data,
    events: {
        'focus:item': function () {
            setTimeout(function () {
                page.rightPanel.reset();
            }, 50);
        }
    }
}));


// panel set: main
page.panelSet = new PanelSet({
    visible: true,
    $node: document.getElementById('panelSetMain'),
    focusIndex: 1,
    panels: [page.leftPanel, page.middlePanel, page.rightPanel]
});
page.add(page.panelSet);


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            if ( page.activeComponent === page.middlePanel.list && page.middlePanel.currentSet !== page.middlePanel.sets.main ) {
                page.middlePanel.reset(page.middlePanel.sets.main);
            } else {
                window.core.call('hide');
            }
            break;
    }
});

// work but no use for this
app.updater.addListeners({
    listChange: function () {
        page.middlePanel.releaseListUpdate();
        if ( app.pages.main.active && page.middlePanel.currentSet === page.middlePanel.sets.options ) {
            page.middlePanel.reset(page.middlePanel.sets.options);
            //window.core.notify({title: _('New software version available'), icon: 'info'});
        }
    },
    hardUpdate: function ( data ) {
        console.log('start update right now with data: ' + JSON.stringify(data));
        if ( data ) {
            app.intent = {action: 'update', data: data};
            app.route(app.pages.logs, [data]);
        }
    }
});

window.core.addListener('intent', function ( intent, callback ) {
    if ( intent.action === 'update' ) {
        setTimeout(function () {
            window.core.call('show');
            window.core.call('focus');
            app.intent = intent;
            if ( intent.data && !intent.data.closeCallback ) {
                console.log('intent.data' + JSON.stringify(intent.data));
                console.log('frequency' + app.updater.frequency);
                if ( app.updater.frequency !== app.updater.constants.NEVER || app.updater.standAloneMode ) {
                    console.log('start update right now');
                    app.route(app.pages.logs, intent.data);
                }
            }
            callback(false, {});
        }, 100);
    }
});

page.addListener('show', function () {
    page.panelSet.show();
    page.panelSet.focus();
    if ( !page.middlePanel.currentSet ) {
        page.middlePanel.reset(page.middlePanel.sets.main);
    }
    page.middlePanel.focus();
    page.rightPanel.reset();
});

window.core.addListeners({
    show: function () { page.clock.start(); },
    hide: function () { page.clock.stop(); }
});

page.middlePanel.releaseListUpdate();
app.route(page);
page.show();

if ( app.updater.standAloneMode ) {
    // in launcher mode we need to tell core that we are ready
    window.core.emit('app:ready');
}

// public
module.exports = page;
